import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from './../../../environments/environment';

@Component({
    selector: 'cmp-header',
    standalone: false,
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, AfterViewInit {

    ngAfterViewInit(): void {

    }

    constructor() { }

    public ngOnInit() {


    }






}
